import React from "react";
import { stats } from "./data";

/** Compact proof-of-size band directly under the hero. */
export function ValueStrip() {
  return <section className="w-full border-y border-[#e3edf8] bg-white px-4 py-6 sm:px-8 sm:py-8" data-id="element-239" data-mp="2jy5hpiahruxy">
      <ul className="mx-auto grid max-w-4xl grid-cols-2 gap-y-5 sm:grid-cols-4" data-id="element-240" data-mp="2ov5qi0yq7bsr">
        {stats.map(s => <li key={s.label} className="text-center" data-id="element-241" data-mp="2torul4qtq7cy">
            <p className="font-serif-display text-3xl font-semibold leading-none text-[var(--accent)] sm:text-4xl" data-id="element-242" data-mp="2xpk6k5r2yqcx">
              {s.value}
            </p>
            <p className="mt-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-[var(--muted)] sm:text-xs" data-id="element-243" data-mp="32q83t95wk3fl">
              {s.label}
            </p>
          </li>)}
      </ul>
    </section>;
}